import { TextField } from '@mui/material';
import { useField } from 'formik';
import React from 'react'

export default function DateTimePickerWrapper({
    name,
    ...otherProps
}) {
    const [field, meta] = useField(name);

    const configDateTimePicket = {
        ...field,
        ...otherProps,
        type: 'date',
        variant: 'outlined',
        fullWidth: true,
        InputLabelProps: {
            shrink: true
        }
    };

    if (meta && meta.touched && meta.error) {
        configDateTimePicket.error = true;
        configDateTimePicket.helperText = meta.error;
    }

    return (
        <TextField
            {...configDateTimePicket}
        />
    )
}
